var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"simple-breadcrumbs container"},[_vm._l((_vm.links),function(link){return [_c('a',{attrs:{"href":link.href}},[_vm._v(_vm._s(link.name))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }